import { AutomationEventTypes } from "../AutomationModuleTypes";
import AutomationCommon from "../common";

const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

class EmailModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        const emailReceivedAttrs = this.emailReceived();
        console.log("emailReceivedAttrs", emailReceivedAttrs);
        return [...emailReceivedAttrs];
    }

    generateEmailAttributes(context, prefix = "") {
        prefix = prefix ? `${prefix}.` : "";

        return [
            ga(context, `${prefix}siteId`, "Site ID"),
            ga(context, `${prefix}messageId`, "Message ID"),
            ga(context, `${prefix}incoming`, "Incoming", vt.BOOLEAN),
            ga(context, `${prefix}sender`, "Sender Email Address"),
            ga(context, `${prefix}senderUserId`, "Sender User Id"),
            ga(context, `${prefix}to_list`, "To Email Address List", vt.ARRAY_STRING),
            ga(context, `${prefix}cc_list`, "CC Email Address List", vt.ARRAY_STRING),
            ga(context, `${prefix}bcc_list`, "BCC Email Address List", vt.ARRAY_STRING),
            ga(context, `${prefix}subject`, "Subject"),
            ga(context, `${prefix}body_text`, "Body Text"),
            ga(context, `${prefix}body_html`, "Body HTML"),
            ga(context, `${prefix}created_at`, "Created Date", vt.DATETIME),
            ga(context, `${prefix}deleted`, "Deleted", vt.BOOLEAN),
            ga(context, `${prefix}replay_to_message_id`, "Replay To Message ID"),
            ga(context, `${prefix}thread_id`, "Thread ID"),
            ga(context, `${prefix}ref_visitor_id`, "Reference Contact", vt.OBJECT, undefined, [
                ...this.parent.generateContactAttributes(`${prefix}ref_visitor_id`),
            ]),
            ga(context, `${prefix}ref_department_ids`, "Reference Department IDS", vt.ARRAY),
            ga(context, `${prefix}is_ticket`, "Is Ticket", vt.BOOLEAN),
            ga(context, `${prefix}attachments`, "Attachments", vt.ARRAY_OBJECT),
        ];
    }

    emailReceived() {
        const e = AutomationEventTypes.EMAIL.RECEIVED;
        const context = contexts.EVENT;

        return [
            ga(context, `event.${e}`, "Received Email", vt.OBJECT, undefined, [
                ga(context, `event.${e}.$..*`, "*", vt.OBJECT),
                ...this.generateEmailAttributes(context, `event.${e}.email`),
            ]),
        ];
    }
}

export default EmailModuleAttributeFactory;
